import React, { useCallback, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { getEndpointUrl } from '../../Utils/Common';
import formElement from '../../Utils/FormInspeksi.json';
import FormElement from './FormElement';
import Loader from "react-js-loader";
import { useNavigate, useParams } from "react-router-dom";
import FormResults from "./FormResults";
import { Helmet } from "react-helmet";
import Header from "../../Layout/Header"

const FormInspeksi = () => {
    const [isLoading, setLoading] = useState(true);

    const navigate = useNavigate();

    const params = useParams();

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [element, setElement] = useState(formElement.filter(item => item.name == 'Remote Entry System dan Alarm').at(0));
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLastForm, setLastForm] = useState(false);
    const [isPrevForm, setPrevForm] = useState(false);

    const [car, setCar] = useState([]);
    const [entry, setEntry] = useState([]);

    const fetchData = useCallback(async (id, index) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/checkpoint/entry/${id !== undefined ? id : 0}?index=${index !== undefined ? index : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`
            })
        }).then(response => response.json()).then(json => {
            if (json.entryStatus === 'ok') {
                let nowArray = formElement.filter(item => item.name == json.results.name).at(0);

                setElement(nowArray);
            } else {
                setElement(formElement.at(index));
            }

            setCar(json.results.item);

            setEntry(json.results.entry);

            setLoading(false);

            clearTimeout();
        }).catch(error => {
            setLoading(true);

            console.log(error);

           // setTimeout(() => fetchData(id), 5000);
        });
    }, []);

    useEffect(() => {
        fetchData(params.offer_id, params.index);

        setCurrentIndex(params.index);

        setLastForm((formElement?.length - 1) == currentIndex);
        setPrevForm((formElement?.length - 1) < currentIndex);

    }, [params, fetchData, currentIndex, isLastForm]);

    const onCallback = useCallback((e) => {
        let nowArray = formElement.filter(item => item.name == e.name).at(0);
        let newElement = formElement.at(formElement.indexOf(nowArray) + 1);

        if (!isLastForm)
            navigate(`/form-inspeksi/${params.offer_id}/${formElement.indexOf(newElement)}`);
        else
            finish();

    }, [isLastForm]);

    const finish = () => {
        setLoading(true);
        fetch(getEndpointUrl() + `/checkpoint/finish/${params.offer_id !== undefined ? params.offer_id : 0}`, {
            method: 'POST',
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok')
                navigate(`/inspeksi/detil/${params.offer_id}`);

            setLoading(false);

            clearTimeout();
        }).catch(error => {
            setLoading(true);

            setTimeout(() => fetchData(params.offer_id), 5000);
        });
    }

    return (
        <>
            <Helmet>
                <title>Form Inspeksi</title>
            </Helmet>
            <Header />
            <Container className="mt-5 mb-5">
                {isLoading ?
                    <div className="text-center mt-5">
                        <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                    </div> : currentIndex == 'review' ?
                        <FormResults />
                        :
                        <FormElement
                            onCallback={(e) => onCallback(e)}
                            car={car}
                            entry={entry}
                            element={element}
                            currentIndex={currentIndex}
                            isPrev={isPrevForm}
                            isLast={isLastForm} />
                }
            </Container>
        </>
    );
}

export default FormInspeksi;
